import { PLAYER_TRANSACTION_HISTORY } from '~/utils/api-response/player'

// State
export const state = () => ({
  loading: false,
  transaction: {
    total: 0,
    total_amount: 0,
    totalPages: 0,
    data: []
  }
})

// Actions
export const actions = {
  // Get transaction history
  getTransactions({ commit }, params) {
    const response = PLAYER_TRANSACTION_HISTORY
    commit('setTransaction', response.data)
  }
}

// Mutations
export const mutations = {
  setLoading(state, data) {
    state.loading = data
  },
  setTransaction(state, data) {
    state.transaction = data
  }
}

// Getters
export const getters = {
  transaction: state => state.transaction
}
